import { Injectable } from "@angular/core";
import { AccountView } from "../../../../models/view/account/account.view";
import { SourceBalancesView } from "../../../../models/view/source-balances/source-balances.view";
import type { FiskilBalance } from "../types/balance.types";

/**
 * Maps Fiskil balance API payloads to vault {@link SourceBalancesView} rows (one per retrieval per account).
 */
@Injectable({
  providedIn: "root",
})
export class FiskilSourceBalanceAction {
  /**
   * Builds a new source-balance row. Returns null if Fiskil did not return a balance for this account.
   */
  toSourceBalanceView(
    account: AccountView,
    fiskilBalance: FiskilBalance | undefined,
  ): SourceBalancesView | null {
    if (!fiskilBalance) {
      return null;
    }
    const now = new Date().toISOString();
    return new SourceBalancesView({
      v: 1,
      id: crypto.randomUUID(),
      vid: "",
      dc: now,
      dm: now,
      acId: account.id,
      bDt: now,
      rw: JSON.stringify(fiskilBalance),
    });
  }
}
